import '../../Styles/PercentageCycle/percentageCycle.scss'

await import('Feature/Common/code/Scripts/Common/forEach');

const chartElementsScrollContainer = document.querySelectorAll('.percentage-cycle-container__element');
const singleChartsCountActiveState = 'percentage-cycle-container__count--active';
const Observer = new IntersectionObserver(isInViewport);
const ObserverOptions = {};
let animationName = 'animation: progress 1.2s ease-out forwards';
let scrollTimer;

function horizontalDivCheck(parent, child) {
    // Check if the element is visible in the cointainer after scrolling / swiping
    let parentRect = parent.getBoundingClientRect();
    let childRect = child.getBoundingClientRect();
    let notVisible = parentRect.left >= childRect.right || parentRect.right <= childRect.left;
    let dots = child.parentElement.nextElementSibling.children;

    if (!notVisible) {
        dots.forEach(function (dot) {
            if (dot.classList.contains(child.attributes.name.value)) {
                dot.classList.add("active");
            } else {
                dot.classList.remove("active");
            }
        })
    }
}

function isInViewport(entries) {
    entries.forEach(function (entry) {
        let circles = entry.target.children;

        circles.forEach(function (circle, i) {
            let strokeWithBefore = circle.querySelector('.circle').getAttribute("stroke-dasharray");
            let addStrokeAttribute = circle.querySelector('.circle').style.strokeDasharray = strokeWithBefore;
            let removeStrokeAttribute = circle.querySelector('.circle').style.strokeDasharray = "0, 100";

            if (entry.isIntersecting) {
                //Little delay to play the animation for each circle at a time
                setTimeout(function () {
                    addStrokeAttribute;
                    circle.querySelector(".circle").setAttribute("style", animationName);
                }, i * 300)
            } else {
                removeStrokeAttribute;
                circle.querySelector(".circle").setAttribute("style", "");
            }
        })
    });
};

function singleChartsDotClick(event) {
    const parent = event.currentTarget.parentElement.parentElement;
    const cssClass = event.currentTarget.classList[0];
    
    if (!event.target.classList.contains('active')) {
        event.target.classList.add('active');
    } else {
        return
    }
    
    parent.querySelectorAll('a').forEach(function (chartsDot) {
        if (chartsDot !== event.target) {
            chartsDot.classList.remove('active');
        }
    });
    parent.querySelectorAll('.percentage-cycle__single-chart').forEach(function (child) {
        if (child.attributes.name.value === cssClass) {
            child.querySelector('.circle').setAttribute('style', 'animation: none');
            child.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'start'
            });
            setTimeout(function () {
                // To see the beautiful animation while sliding the pages.
                child.querySelector('.circle').setAttribute('style', animationName);
            }, 50);
        }
    })
}
const chartElementsSlider = function (elements, element, count) {
    const singleChartElements = elements;
    const singleChartCountContainer = count;

    function singleChartsAppendEl(dots) {
        // In this area we create the dots
        singleChartCountContainer.appendChild(dots);
    }
    singleChartElements.forEach(function (charts, index) {
        charts.setAttribute('name', 'charts-' + index);
        var singleChartsCountDots = document.createElement('a');
        var singleChartsCircleAnimation = charts.querySelector('.circle');
        singleChartsCountDots.setAttribute('class', charts.attributes.name.value);
        // Set active class of first element
        if (singleChartsCountDots.classList.contains('charts-0')) {
            singleChartsCountDots.classList.add('active');
        }
        // bind clickhandler on the generated dot items and pass the event
        singleChartsCountDots.setAttribute('onclick', 'singleChartsDotClick(event)');
        singleChartsAppendEl(singleChartsCountDots);
    });
    //since we are only showing the slider on mobile, we add a active state for css targeting
    singleChartCountContainer.classList.add(singleChartsCountActiveState);
};
if (chartElementsScrollContainer.length) {
    for (var i = 0; i < chartElementsScrollContainer.length; i++) {
        chartElementsScrollContainer[i].addEventListener('scroll', function (data) {
            const target = data.currentTarget;
            if (scrollTimer !== null) {
                clearTimeout(scrollTimer);
            }
            scrollTimer = setTimeout(function () {
                target.children.forEach(function (child) {
                    let parent = child.parentElement;
                    horizontalDivCheck(parent, child);
                });
            }, 50);
        }, false);
    }
    chartElementsScrollContainer.forEach(function (chartElement) {
        const elements = chartElement.querySelectorAll('.percentage-cycle__single-chart');
        const paginationDots = chartElement.nextElementSibling;

        chartElementsSlider(elements, chartElement, paginationDots);
        Observer.observe(chartElement, ObserverOptions);
    });
}